<template>
  <CContainer class="d-flex content-center min-vh-100">
    <CRow>
      <CCol>
        <CCardGroup>
          <CCard class="p-4" style="min-width:300px; max-width:300px; background-color:#3c2468; border:none" 
            text-color="white">
            <CCardBody>
              <CForm>
                <h1 style="color:white; font-size:26px;">Portal Admin vapp</h1>
                <p class="text-muted" style="color:white">Reportes Vapp</p>
                <CInput
                  placeholder="Usuario"
                  autocomplete="Usuario"
                  v-model="usuario.username"
                  @keyup.enter.native="iniciarSesion"
                ></CInput>
                <CInput
                  placeholder="Contraseña"
                  type="password"
                  autocomplete="contraseña"
                  v-model="usuario.passw"
                  @keyup.enter.native="iniciarSesion"></CInput>
                <CRow>
                  <CCol col="12" class="text-left">
                    <CAlert style="max-width:250px" closeButton v-show="showMensaje" :color="tipoMensaje">{{mensajeLogin}}</CAlert>
                  </CCol>
                </CRow>
                <CRow v-show="!showMensajeCambioPass">
                  <CCol :col="(isLogin)?'5':'6'" class="text-rigth"></CCol>
                  <CCol :col="(isLogin)?'7':'6'" class="text-rigth">
                    <CButton style="background-color:#0b7689;color:white;" class="px-4" @click="iniciarSesion" :disabled="isLogin">
                      
                      <span v-if="isLogin">Ingresando...</span>
                      <span v-else>Ingresar</span>
                    </CButton>
                  </CCol>
                  <!--<CCol col="6" class="text-right">
                    <CButton color="link" class="px-0">Forgot password?</CButton>
                    <CButton color="link" class="d-md-none">Register now!</CButton>
                  </CCol>-->
                </CRow>
                <CRow class="mt-2" v-show="showMensajeCambioPass">
                  <CCol sm="12" md="12" lg="12">
                    <CRow>
                      <CAlert :color="tipoMensaje" style="max-width:250px">{{msjCambiarPass}}</CAlert>
                    </CRow>
                    <CRow v-show="!enviandoSolicitud">
                      <CCol sm="8" md="8" lg="6">
                        <CButton style="background-color:#0b7689;color:white;" @click="loguearUser">Luego</CButton>
                      </CCol>
                      <CCol sm="4" md="4" lg="6">
                        <CButton style="background-color:#0b7689;color:white;" @click="cambiarContraseña()">Si!</CButton>
                      </CCol>
                    </CRow>
                    <CRow v-show="enviandoSolicitud">
                      <CCol sm="12" md="12" lg="12">{{msjSolicitandoCambio}}</CCol>
                    </CRow>
                  </CCol>
                </CRow>
                
              </CForm>
            </CCardBody>
          </CCard>

          <!--<CCard
            color="primary"
            text-color="white"
            class="text-center py-5 d-sm-down-none"
            body-wrapper
          >
            <h1>Sistema de Reportes VAPP</h1>
            <p>Para ingresar utilice su usuario y contraseña otorgado por vapp, en caso de no disponer uno contacte a soporte de vapp al correo soporte@vapp.cl</p>
            <CButton
              color="primary"
              class="active mt-3"
            >
              Register Now!
            </CButton>
          </CCard>-->
        </CCardGroup>
      </CCol>
    </CRow>
  </CContainer>
</template>


<style scoped>
  .imgr{
      -webkit-animation: 3s rotate linear infinite;
      animation: 3s rotate  linear infinite;
      -webkit-transform-origin: 50% 50%;
      transform-origin: 50% 50%;
  }
</style>

<script>
  import cons from '@/const'
  import axios from "axios"
  
    import { freeSet } from "@coreui/icons";
        

  export default {
    name: 'LoginAdmin',
    freeSet,
    
    data () {
      return {
        //expiracionCookie: "8h",
        baseUrl: cons.protocolo+"://" + cons.ipServer + cons.puerto,
        isLogin: false,
        enviandoSolicitud: false,
        msjSolicitandoCambio: "",

        tipoMensaje: "success",
        showMensaje : false,
        mensajeLogin: "",
        showMensajeCambioPass: false,
        msjCambiarPass: "Su contraseña está por defecto, Le recomendamos cambiar la contraseña por seguridad",
        cambiarPss: false,

        usuario: {
          username:"",
          passw:""
        },

        logueoResp: null,
      }
    },
    beforeMount() {
      
      cons.puertoQa = ("port" in this.$route.query) ? this.$route.query.port : "",
      this.validarSesion()
      console.log(cons.puertoQa)
    },
    methods: {
      iniciarSesion: function(){
        if(this.usuario.username == null 
          || this.usuario.username == "" 
          || this.usuario.passw == null 
          || this.usuario.passw == "" ){

          this.showMensaje = true
          this.mensajeLogin = "Ingrese correctamente sus datos"
          this.tipoMensaje = "danger"


        } else{

        this.isLogin = true
        
        var url = this.baseUrl + "/log_in_vapp/" + this.usuario.username + "/" + this.usuario.passw
        axios({
              method: "POST", 
              "url": url,
          }).then(result => {

            this.loguearUser(result.data)
            this.isLogin = false
            
          }, error => {
              this.tipoMensaje = "danger"
              this.mensajeLogin = error.response.data
              this.showMensaje = true
              
            this.isLogin = false
          })
          .finally(() => {
          });
        }
        /*if(this.usuario.username == null || this.usuario.username == "" || this.usuario.pass == null || this.usuario.pass == ""){
          this.showMensaje = true
          this.mensajeLogin = "Ingrese correctamente sus datos"
          this.tipoMensaje = "danger"

        }else{
          this.showMensaje = false
          
          axios({
              method: "POST", 
              "url": url,
          }).then(result => {
            console.log(result).data
            this.isLogin = true
          }, error => {
              this.tipoMensaje = "danger"
              this.mensajeLogin = error.response.data
              this.showMensaje = true
          })
          .finally(() => {
          });
          
          
        }
        */
        
      },
      loguearUser: function(userLog){

        let cookieUsername = this.$cookie.get('userLogginTokenAdmin')

        if(cookieUsername === null || cookieUsername === ""){

          this.$cookie.set("userLogginTokenAdmin", JSON.stringify(userLog), { expires: userLog.fechaExpToken });

        } else {

          if(userLog.tokenUsuario != JSON.parse(cookieUsername).tokenUsuario){
            this.$cookie.set("userLogginTokenAdmin", JSON.stringify(userLog), { expires: userLog.fechaExpToken });
          }

        }

        this.showMensaje = true
        this.mensajeLogin = "Bienvenido " + this.usuario.username
        this.tipoMensaje = "success"
        console.log(userLog.rutaRedireccion)
        this.$router.push(userLog.rutaRedireccion);

      },
      
      /*cambiarContraseña: function(){

        this.enviandoSolicitud = true
        this.msjSolicitandoCambio = "Enviando Solicitud"
        var url = cons.port+"://" + cons.ipServer + "/solicitar_cambio_pass/"
        
        axios({
            method: "GET", 
            "url": url,
            "headers": {
                'Authorization': `${this.logueoResp.tokenUsuario}`
            }
        }).then(result => {

          this.msjSolicitandoCambio = "Solicitud enviada, revise su correo."
          this.$notification.success(result.data, {  timer: 10, position:"bottomRight"});

              
          this.$notification.error(error.response.data, {  timer: 10, position:"bottomRight"});
        })
        .finally(() => {
          
        });
      },*/

      validarSesion: function(){
        let cookieUsername = this.$cookie.get('userLogginAdminToken')

        if(cookieUsername !== null ){
          
          this.$router.push(JSON.parse(cookieUsername).rutaRedireccion);
        }    
      }

    }
  }
</script>

